// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"c7dbb85d","420":"c7dbb85d"}[chunkId] + ".chunk.css";
};